import Currencies from '../dynamics/currencies.json'

export const getCurrencyById = (currencyId) => Currencies.find(({ id }) => id === currencyId)